<template functional>
  <div>
    <price-format
      :format="props.row.price_format"
      :value="props.row['price']"
    />
  </div>
</template>

<script>
export default {
  name: 'PriceFormatter',
};
</script>
